<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :disabled="menuDisabled"
        location="bottom end"
        origin="auto"
        content-class="rounded-lg"
    >
        <template #activator="{ props }">
            <v-icon-btn
                v-bind="props"
                :icon="mdiMagnify"
                aria-label="Search Menu"
                @click="onClick"
                tile
            ></v-icon-btn>
        </template>

        <SearchPanel
            @on-close="onClose()"
            :min-width="320"
        ></SearchPanel>
    </v-menu>
</template>

<script lang="ts" setup>
    import SearchPanel from '~/components/search/SearchPanel/SearchPanel.vue';
    import { mdiMagnify } from '@mdi/js';

    const props = defineProps<{
        menuDisabled?: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'click', event: Event): void;
    }>();

    const menu = ref<boolean>(false);

    function onClick(e: Event) {
        if (props.menuDisabled) {
            e.preventDefault();
            e.stopPropagation();
        }

        emit('click', e);
    }

    function onClose(): void {
        menu.value = false;
    }
</script>

<style lang="scss"></style>
